<template>
  <div class="w-full w-full bg-white rounded-lg p-6 text-gray-800">
    <div class="flex items-center justify-end">
      <!-- <div
        v-if="!manageSeasons"
        class="flex items-center justify-center px-3 border text-sm rounded-lg select-none
          cursor-pointer hover:text-gray-600 duration-500 transition-all"
        style="padding-top: 0.35rem; padding-bottom: 0.35rem;"
        @click="manageSeasons = true"
      >
        <i class="fas fa-calendar-week mr-1 leading-none" />
        <div style="margin-left: 2px;">
          Manage seasons
        </div>
      </div> -->
      <!-- <div
        v-if="manageSeasons"
        class="flex items-center justify-center px-3 border text-sm rounded-lg select-none
          cursor-pointer hover:text-gray-600 duration-500 transition-all mr-2"
        style="padding-top: 0.25rem; padding-bottom: 0.25rem;"
        @click="addNewSeason()"
      >
        <i
          class="fas fa-plus mr-1 leading-none"
          style="height: 10px;"
        />
        <div style="margin-left: 2px;">
          Add new season
        </div>
      </div> -->
      <div
        v-if="manageSeasons"
        class="flex items-center justify-center px-3 border border-gray-700 text-sm rounded-lg select-none
          cursor-pointer duration-500 transition-all bg-gray-700 hover:bg-gray-600 text-white"
        style="padding-top: 0.25rem; padding-bottom: 0.25rem;"
        @click="confirm()"
      >
        <i
          class="fas fa-check mr-1 leading-none"
          style="height: 10px;"
        />
        <div style="margin-left: 2px;">
          Confirm
        </div>
      </div>
    </div>

    <div
      v-if="manageSeasons && error"
      class="text-sm text-red-600 mt-2 -mb-4"
    >
      There is an problem with your seasons, please ensure that all seasons have a start and end month, there are no months missing and that they do not overlap.
    </div>

    <div
      v-for="(season, index) in seasons"
      :key="'season' + index"
      class="mt-0"
    >
      <div v-if="!manageSeasons">
        <div
          class="flex items-center justify-start text-base rounded-lg
          text-gray-800 font-bold tracking-wide leading-none"
        >
          Season <span class="text-gray-500 ml-2">{{ months.filter(month => month.value === season.startingMonth )[0].name }} - {{ months.filter(month => month.value === season.endingMonth )[0].name }}</span>
        </div>

        <div
          class="border rounded-lg mt-4"
        >
          <div class="flex bg-gray-50 rounded-t-lg border-b">
            <div
              class="flex items-center justify-center text-center text-sm text-gray-400 border-r"
              style="width: 12.5%"
            >
              <div class="leading-none">
                Time
              </div>
            </div>
            <div
              v-for="(day, dayIndex) in daysValues"
              :key="day.value + 'season' + index"
              class="text-center h-10 text-sm flex items-center justify-center"
              :class="day.day !== 'Sun' ? 'border-r' : ''"
              style="width: 12.5%"
            >
              <div>
                <CheckboxItem
                  :title="dayIndex + '-' + index"
                  :display-info="false"
                  :default-value="season.days[dayIndex].enabled"
                  @change="valueChanged"
                />
              </div>
              <div
                class="ml-1"
                style="margin-bottom: 2px;"
              >
                {{ day.day }}
              </div>
            </div>
          </div>

          <div class="flex">
            <!-- <div
              class="text-sm bg-gray-50 border-r rounded-bl-lg"
              style="width: 12.5%;"
            >


            </div> -->

            <div class="w-full">
              <div class="flex w-full">
                <div
                  style="width: 12.5%"
                  class="h-10 text-gray-800 flex items-center justify-center text-sm leading-none border-b border-r bg-gray-50"
                >
                  Start
                </div>
                <div
                  v-for="(day, i) in daysValues"
                  :key="day + 'start' + i"
                  style="width: 12.5%"
                  class="flex items-center justify-center h-10 border-b"
                  :class="day.day !== 'Sun' ? 'border-r' : ''"
                >
                  <input
                    v-if="season.days[i].enabled"
                    v-model="season.days[i].startTime"
                    type="time"
                    class="form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 inline-block w-full min-w-full text-center h-full"
                    style="border-width: 0; border-radius: 0; padding: 0; padding-left: 0.75rem; padding-right: 0.5rem;"
                    @change="setDefaultTimes()"
                  >
                  <div
                    v-else
                    class="bg-gray-100 w-full h-full"
                  />
                </div>
              </div>

              <div class="flex w-full">
                <div
                  style="width: 12.5%"
                  class="h-10 text-gray-800 flex items-center justify-center text-sm leading-none p-2 border-r bg-gray-50 rounded-bl-lg"
                >
                  End
                </div>
                <div
                  v-for="(day, i) in daysValues"
                  :key="day + 'end' + i"
                  style="width: 12.5%"
                  class="flex items-center justify-center h-10"
                  :class="day.day !== 'Sun' ? 'border-r' : 'rounded-br-lg overflow-hidden'"
                >
                  <input
                    v-if="season.days[i].enabled"
                    v-model="season.days[i].endTime"
                    type="time"
                    class="form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 inline-block w-full min-w-full text-center h-full"
                    style="border-width: 0; border-radius: 0; padding: 0; padding-left: 0.75rem; padding-right: 0.5rem;"
                    @change="setDefaultTimes()"
                  >
                  <div
                    v-else
                    class="bg-gray-100 w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="text-center shadow  rounded-lg"
      >
        <div class="w-full min-w-full flex items-center justify-end bg-gray-100 h-6 border border-b-0 rounded-t-lg">
          <div
            :class="index === 0 ? 'text-gray-400' : 'text-gray-800 hover:text-gray-600 transition-all duration-500 cursor-pointer'"
            :title="index === 0 ? 'Must have at least 1 season' : 'Delete season' "
            class="p-1 px-2"
            style="margin-bottom: 2px;"
            @click="deleteSeason(index)"
          >
            <div><i class="fas fa-times text-sm" /></div>
          </div>
        </div>
        <div
          class="flex"
          style="width: 100%;"
        >
          <div class="w-52 text-lg tracking-wide flex items-center justify-center bg-gradient-to-br rounded-bl-lg from-gray-500 to-gray-800 text-white font-semibold px-6 py-2 shadow z-10">
            Season {{ index + 1 }}
          </div>

          <div class="w-full">
            <div class="flex w-full border border-l-0 border-t-0 rounded-br-lg text-gray-600">
              <div class="w-1/3 text-center border-r p-3">
                <div class="font-bold text-sm">
                  Starting month
                </div>
                <div class="relative inline-block text-left">
                  <div>
                    <button
                      type="button"
                      class="inline-flex justify-center w-full rounded-md
                    bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                      aria-haspopup="true"
                      aria-expanded="true"
                      @click="switchStartMenuState(index)"
                    >
                      {{ getSelectedStartMonth(index) }}
                      <svg
                        class="-mr-1 ml-2 h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  <div
                    v-if="season.startDateDropdownOpen"
                    class="origin-top-right absolute right-0 mt-1 z-20 w-56 rounded-lg overflow-hidden shadow-lg bg-white border"
                  >
                    <div
                      class="max-h-44 overflow-y-auto"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div
                        v-for="month in months"
                        class="block px-3 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        @click="setStartMonth(month.value, index)"
                      >
                        {{ month.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-1/3 text-center border-r p-3">
                <div class="font-bold text-sm">
                  Ending month
                </div>
                <div class="relative inline-block text-left">
                  <div>
                    <button
                      type="button"
                      class="inline-flex justify-center w-full rounded-md
                    bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                      @click="switchEndMenuState(index)"
                    >
                      {{ getSelectedEndMonth(index) }}
                      <svg
                        class="-mr-1 ml-2 h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  <div
                    v-if="season.endDateDropdownOpen"
                    class="origin-top-right absolute right-0 mt-1 z-10 w-56 rounded-lg overflow-hidden shadow-lg bg-white border"
                  >
                    <div
                      class="max-h-44 overflow-y-auto"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div
                        v-for="month in months"
                        class="block px-3 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        @click="setEndMonth(month.value, index)"
                      >
                        {{ month.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-1/3 text-center border-r p-3">
                <div class="font-bold text-sm">
                  Maximum players
                </div>
                <div class="relative inline-block text-left">
                  <div>
                    <button
                      type="button"
                      class="inline-flex justify-center w-full rounded-md
                    bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                      @click="switchMaxPlayersMenuState(index)"
                    >
                      {{ season.maxPlayers }}
                      <svg
                        class="-mr-1 ml-2 h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>

                  <div
                    v-if="season.maxPlayersDropdownOpen"
                    class="origin-top-right absolute right-0 mt-1 z-10 w-56 rounded-lg overflow-hidden shadow-lg bg-white border"
                  >
                    <div
                      class=""
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div
                        v-for="value in 4"
                        class="block px-3 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                        @click="setMaxPlayers(value, index)"
                      >
                        {{ value }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Dropdown from '@/app/shared/components/dropdown/dropdown.vue';
import CheckboxItem from '@/app/shared/components/form/checkbox/checkboxItem.vue';

export default {
  name: 'TeeConfig',

  components: {
    CheckboxItem,
    Dropdown,
  },

  props: {
    daysProp: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      manageSeasons: false,
      error: false,

      seasons: [
        {
          startDefaultTimesSet: false,
          endDefaultTimesSet: false,

          startingMonth: 1,
          endingMonth: 12,
          maxPlayers: 4,
          startDateDropdownOpen: false,
          endDateDropdownOpen: false,
          maxPlayersDropdownOpen: false,
        },
      ],

      daysValues: [
        { day: 'Mon', value: 1 },
        { day: 'Tue', value: 2 },
        { day: 'Wed', value: 4 },
        { day: 'Thu', value: 8 },
        { day: 'Fri', value: 16 },
        { day: 'Sat', value: 32 },
        { day: 'Sun', value: 64 },
      ],

      months: [
        { name: 'January', value: 1 },
        { name: 'February', value: 2 },
        { name: 'March', value: 3 },
        { name: 'April', value: 4 },
        { name: 'May', value: 5 },
        { name: 'June', value: 6 },
        { name: 'July', value: 7 },
        { name: 'August', value: 8 },
        { name: 'September', value: 9 },
        { name: 'October', value: 10 },
        { name: 'November', value: 11 },
        { name: 'December', value: 12 },
      ],

      days: [true, true, true, true, true, true, true],
    };
  },

  computed: {
    ...mapState({
      selectedCourse: state => state.course.selectedCourse,
    }),

    availableDays() {
      return this.days;
    },

    availableTimes() {
      const times = [];


      var intervalDate = new Date();
      intervalDate.setHours(0, 0, 0, 0);
      times.push(intervalDate);

      for (let i = 0; i < 24 * 60 - this.selectedCourse.interval; i += this.selectedCourse.interval) {
        var intervalDate = new Date();
        intervalDate.setHours(0, 0, 0, 0);
        intervalDate.setMinutes(intervalDate.getMinutes() + i);
        times.push(intervalDate);
      }

      return times;
    },

    getSelectedMonths() {
      const selectedMonths = [];

      this.seasons.forEach((season) => {
        selectedMonths.push(...this.getMonthsFromRange(season.startingMonth, season.endingMonth));
      });

      if (this.error && selectedMonths.length === 12 && !this.monthIsUndefined) {
        this.error = false;
      }

      return selectedMonths.sort();
    },

    monthIsUndefined() {
      return this.seasons.filter(s => s.startingMonth === undefined || s.endingMonth === undefined).length > 0;
    },
  },

  watch: {
    seasons: {
      handler(item) {
        this.$emit('change', this.seasons);
      },
      deep: true,
    },

    manageSeasons() {
      this.$emit('manageSeasons', this.manageSeasons);
    },

    daysProp: {
      handler(newDays, oldDays) {
        // Re-initialize seasons when daysProp changes (course selection changed)
        console.log('[TeeConfig] daysProp changed:', {
          newDays,
          newDaysLength: newDays ? newDays.length : 0,
          oldDaysLength: oldDays ? oldDays.length : 0,
          isArray: Array.isArray(newDays),
        });
        // Always re-initialize if we have new days data
        if (newDays && Array.isArray(newDays)) {
          console.log('[TeeConfig] Initializing days from prop');
          this.$nextTick(() => {
            this.initializeDaysFromProp();
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    this.initializeDaysFromProp();
  },

  mounted() {
    this.$emit('change', this.seasons);
  },

  methods: {
    initializeDaysFromProp() {
      console.log('[TeeConfig] initializeDaysFromProp called with daysProp:', this.daysProp);
      
      const defaultDays = [
        {
          value: 1, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 2, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 4, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 8, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 16, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 32, enabled: false, startTime: null, endTime: null,
        },
        {
          value: 64, enabled: false, startTime: null, endTime: null,
        },
      ];

      const newDays = [];
      defaultDays.forEach((dayValue) => {
        const newDayValue = { ...dayValue };
        const day = this.daysProp && Array.isArray(this.daysProp) && this.daysProp.length > 0 
          ? this.daysProp.find(d => d.dayOfWeek === dayValue.value)
          : undefined;
        
        if (day !== undefined && day.startTime && day.endTime) {
          try {
            // Handle both ISO format (with 'T') and time-only format
            let startTime, endTime;
            if (typeof day.startTime === 'string' && day.startTime.includes('T')) {
              const timePart = day.startTime.split('T')[1];
              startTime = timePart.split(':');
            } else if (typeof day.startTime === 'string' && day.startTime.includes(':')) {
              startTime = day.startTime.split(':');
            } else {
              startTime = ['00', '00'];
            }
            
            if (typeof day.endTime === 'string' && day.endTime.includes('T')) {
              const timePart = day.endTime.split('T')[1];
              endTime = timePart.split(':');
            } else if (typeof day.endTime === 'string' && day.endTime.includes(':')) {
              endTime = day.endTime.split(':');
            } else {
              endTime = ['00', '00'];
            }
            
            newDayValue.id = day.id;
            newDayValue.enabled = true;
            newDayValue.startTime = `${startTime[0]}:${startTime[1]}`;
            newDayValue.endTime = `${endTime[0]}:${endTime[1]}`;
            
            console.log(`[TeeConfig] Enabled day ${dayValue.value}:`, {
              startTime: newDayValue.startTime,
              endTime: newDayValue.endTime,
              originalStart: day.startTime,
              originalEnd: day.endTime,
            });
          } catch (error) {
            console.error('Error parsing day times:', error, day);
            newDayValue.enabled = false;
          }
        } else {
          newDayValue.enabled = false;
        }

        newDays.push(newDayValue);
      });
      
      console.log('[TeeConfig] Initialized days:', newDays);

      // Reset seasons and set new days using Vue.set for reactivity
      if (!this.seasons || this.seasons.length === 0) {
        this.$set(this, 'seasons', [{
          startDefaultTimesSet: false,
          endDefaultTimesSet: false,
          startingMonth: 1,
          endingMonth: 12,
          maxPlayers: 4,
          startDateDropdownOpen: false,
          endDateDropdownOpen: false,
          maxPlayersDropdownOpen: false,
          days: newDays,
        }]);
      } else {
        // Use Vue.set to ensure reactivity when replacing the days array
        this.$set(this.seasons[0], 'days', newDays);
      }
      
      // Reset default times flags
      if (this.seasons[0]) {
        this.$set(this.seasons[0], 'startDefaultTimesSet', false);
        this.$set(this.seasons[0], 'endDefaultTimesSet', false);
      }
      
      // Force Vue to update the view
      this.$forceUpdate();
      
      // Emit change to update parent
      this.$nextTick(() => {
        this.$emit('change', this.seasons);
        console.log('[TeeConfig] Emitted change event with seasons:', this.seasons);
      });
    },

    confirm() {
      if (this.getSelectedMonths.length === 12 && !this.monthIsUndefined) {
        this.manageSeasons = false;
      } else {
        this.error = true;
      }
    },

    getMonthsFromRange(startMonth, endMonth) {
      const months = [];

      for (let i = startMonth; i < (startMonth + 12); i++) {
        let index = i;
        if (index > 12) {
          index -= 12;
        }

        months.push(index);
        if (index === endMonth) {
          break;
        }
      }
      return months;
    },

    deleteSeason(index) {
      if (index !== 0) {
        const r = confirm(`Are you sure you want to delete season ${index + 1}?`);
        if (r == true) {
          this.seasons.splice(index, 1);
        }
      }
    },

    switchStartMenuState(index) {
      this.seasons[index].startDateDropdownOpen = !this.seasons[index].startDateDropdownOpen;

      if (this.seasons[index].startDateDropdownOpen) {
        let i = 0;
        this.seasons.forEach((season) => {
          if (i !== index) {
            season.startDateDropdownOpen = false;
          }
          i++;

          season.endDateDropdownOpen = false;
          season.maxPlayersDropdownOpen = false;
        });
      }
    },

    switchEndMenuState(index) {
      this.seasons[index].endDateDropdownOpen = !this.seasons[index].endDateDropdownOpen;

      if (this.seasons[index].endDateDropdownOpen) {
        let i = 0;
        this.seasons.forEach((season) => {
          if (i !== index) {
            season.endDateDropdownOpen = false;
          }
          i++;

          season.startDateDropdownOpen = false;
          season.maxPlayersDropdownOpen = false;
        });
      }
    },

    switchMaxPlayersMenuState(index) {
      this.seasons[index].maxPlayersDropdownOpen = !this.seasons[index].maxPlayersDropdownOpen;

      if (this.seasons[index].maxPlayersDropdownOpen) {
        let i = 0;
        this.seasons.forEach((season) => {
          if (i !== index) {
            season.maxPlayersDropdownOpen = false;
          }
          i++;

          season.startDateDropdownOpen = false;
          season.endDateDropdownOpen = false;
        });
      }
    },

    setDefaultTimes() {
      this.seasons.forEach((season) => {
        season.days.forEach((day) => {
          if (day.enabled) {
            if (day.startTime !== null && !season.startDefaultTimesSet) {
              season.days.forEach((day2) => {
                day2.startTime = day.startTime;
              });
              season.startDefaultTimesSet = true;
            }

            if (day.endTime !== null && !season.endDefaultTimesSet) {
              season.days.forEach((day2) => {
                day2.endTime = day.endTime;
              });
              season.endDefaultTimesSet = true;
            }
          }
        });
      });
    },

    setMaxPlayers(value, index) {
      this.seasons[index].maxPlayers = value;
      this.seasons[index].maxPlayersDropdownOpen = false;
    },

    setStartMonth(value, index) {
      this.seasons[index].startingMonth = value;
      this.seasons[index].startDateDropdownOpen = false;
    },

    setEndMonth(value, index) {
      this.seasons[index].endingMonth = value;
      this.seasons[index].endDateDropdownOpen = false;
    },

    getSelectedStartMonth(index) {
      const month = this.months.filter(month => month.value === this.seasons[index].startingMonth);
      if (month[0] === undefined) {
        return 'None';
      }
      return month[0].name;
    },

    getSelectedEndMonth(index) {
      const month = this.months.filter(month => month.value === this.seasons[index].endingMonth);
      if (month[0] === undefined) {
        return 'None';
      }
      return month[0].name;
    },

    getAvailableMonths() {
      return this.months;
    },

    addNewSeason() {
      this.seasons.push({
        startDefaultTimesSet: false,

        startingMonth: undefined,
        endingMonth: undefined,
        maxPlayers: 4,

        startDateDropdownOpen: false,
        endDateDropdownOpen: false,
        maxPlayersDropdownOpen: false,
        days: [
          {
            value: 1, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 2, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 4, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 8, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 16, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 32, enabled: true, startTime: null, endTime: null,
          },
          {
            value: 64, enabled: true, startTime: null, endTime: null,
          },
        ],
      });
    },

    valueChanged(item) {
      const dayIndex = item.title.split('-')[0];
      const seasonIndex = item.title.split('-')[1];
      this.seasons[seasonIndex].days[dayIndex].enabled = item.value;
      this.$forceUpdate();
    },

    getIndex(day) {
      switch (day) {
        case 'Mon':
          return 0;
          break;
        case 'Tue':
          return 1;
          break;
        case 'Wed':
          return 2;
          break;
        case 'Thu':
          return 3;
          break;
        case 'Fri':
          return 4;
          break;
        case 'Sat':
          return 5;
          break;
        case 'Sun':
          return 6;
          break;
      }
    },
  },

};
</script>
